﻿export default class StepIndicator extends HTMLOListElement {

    connectedCallback() {

        this.querySelector('.step-indicator-active').scrollIntoView(true, {
            behavior: 'smooth', inline: "nearest"
        });
    }

}

customElements.define('step-indicator', StepIndicator, { extends: "ol" });